import { createTransform } from "redux-persist";
import type { CasesClientSearchState } from "./casesClientSearchSlice";

function stripEphemeral(s: CasesClientSearchState | undefined): CasesClientSearchState | undefined {
  if (!s || typeof s !== "object") return s;
  return {
    ...s,
    viewClientsActiveCases: null,
    createNewCaseForSelectedClient: false,
  };
}

export const casesClientSearchPersistTransform = createTransform(stripEphemeral, stripEphemeral, {
  whitelist: ["casesClientSearch"],
});
